export const REDIRECT_PATH_KEY = 'redirect-path';
